import { useState } from "react";
import {
  IconButton,
  Popover,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import moment from "moment";

const PoInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "po-info-popover" : undefined;

  const list = [
    { label: "PO Number", value: data.purchase_order_number || "-" },
    {
      label: "PO Rate",
      value: `₹ ${Number(data.po_rate ?? 0).toFixed(0)}/-`,
    },
    {
      label: "Payment Condition",
      value: data.payment_condition ? `${data.payment_condition} days` : "-",
    },
    { label: "Broker", value: data.broker || "-" },
    { label: "Brand", value: data.brand || "-" },
    {
      label: "Miller Bill No",
      value: data.miller_bill_number || "-",
    },
    {
      label: "Miller Bill Date",
      value: data.dispatch_date
        ? moment(data.dispatch_date).format("ddd, MMM Do YYYY")
        : "-",
    },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography fontSize="0.775rem">
          {data.purchase_order_number || "-"}
        </Typography>
        <IconButton
          size="small"
          onClick={handleOpen}
          sx={{ paddingLeft: "4px" }}
        >
          <Info fontSize="inherit" />
        </IconButton>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minWidth: "250px",
          }}
        >
          {list.map((item, index) => (
            <Box key={index} mb={index < list.length - 1 ? 1 : 0}>
              <Typography
                fontSize="0.775rem"
                display="flex"
                justifyContent="space-between"
              >
                <span style={{ color: "#6b7280" }}>{item.label}:</span>
                <span>{item.value}</span>
              </Typography>
              {index < list.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default PoInfo;
